import * as React from 'react';
import { Button, Form } from 'antd';
import autobind from 'autobind-decorator';
import * as uuid from 'uuid';

import { ZuluIcon } from 'src/app/shared/icon';

interface IUploadViewProps {
    mode: ControlMode;
    label?: string;
    value: any;
    required?: boolean;
    onChange?: (newValue: any) => void;
}

interface IUploadViewState {
    value: any
}

export class UploadView extends React.Component<IUploadViewProps, IUploadViewState> {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value
        };

        this.id = uuid.v4();
    }

    private id: string;

    @autobind
    onChange(event: any) {
        const file = event.target.files[0];
        this.props.onChange(file);

        this.setState({
            value: file.name
        });
    }

    render() {
        const cursor = this.props.mode == 'display' ? 'not-allowed' : 'pointer';
        const disabled = this.props.mode == 'display';
        const targetId = `file-${this.id}`;

        return (
            <Form.Item
                label={this.props.label}
                required={this.props.required}>
                <label
                    className="text-center"
                    style={{ cursor }}
                    htmlFor={targetId}>
                    <input
                        id={targetId}
                        type="file"
                        style={{ display: 'none' }}
                        disabled={disabled}
                        onChange={this.onChange}
                    />
                    <Button
                        style={{ pointerEvents: 'none' }}
                        disabled={disabled}>
                        <ZuluIcon type="upload" />
                        {this.props.value}
                    </Button>
                </label>
            </Form.Item>
        );
    }
}



// WEBPACK FOOTER //
// ./src/core/ui/upload.view.tsx